import {ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, forwardRef, inject, input, InputSignal, output, OutputEmitterRef,} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {IconComponent} from '../../icon/icon.component';
import {ICONS} from '../../../constants/icons/icons.constants';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IconComponent,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        },
    ],
})
export class CheckboxComponent implements ControlValueAccessor {
    public changed: OutputEmitterRef<boolean> = output<boolean>();
    public id: InputSignal<string> = input.required<string>();
    public isChecked: InputSignal<boolean> = input<boolean>(false);
    public isDisabled: InputSignal<boolean> = input<boolean>(false);
    public labelText: InputSignal<string> = input.required<string>();
    public qaTag: InputSignal<string> = input<string>('checkbox');
    protected readonly ICONS = ICONS;
    protected isCheckedByForm: boolean = false;
    protected isDisabledByForm: boolean = false;
    private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    private onChange: (value: boolean) => void;
    private onTouched: () => void;

    public constructor() {
        this.onChange = (): void => {
        };

        this.onTouched = (): void => {
        };

        effect(() => {
            const isChecked = this.isChecked();
            if (isChecked !== this.isCheckedByForm) {
                this.isCheckedByForm = isChecked;
            }
        });
    }

    public writeValue(value: boolean): void {
        this.isCheckedByForm = value ?? false;
        this.changeDetectorRef.markForCheck();
    }

    public registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.isDisabledByForm = isDisabled;
        this.changeDetectorRef.markForCheck();
    }

    protected onCheckboxChange(event: Event): void {
        const isChecked = (event.target as HTMLInputElement).checked;

        this.isCheckedByForm = isChecked;
        this.onChange(isChecked);
        this.changed.emit(isChecked);
    }

    protected onCheckboxBlur(): void {
        this.onTouched();
    }
}
